module.exports = __webpack_public_path__ + "static/media/drag_and_drop_file_icon.7d5178d0.svg";